import pushToDataLayer from "../../util/dataLayer.ts";

export enum CallMeStatus {
    Ok = "ok",
    Error = "error",
    NotSent = "not-sent",
}

export enum CallMeType {
    Inline = "inline",
    Floating = "floating"
}

export function PushCallMeEvent(id: string, hph1: string, hph2: string, type: CallMeType, status: CallMeStatus) {
    pushToDataLayer({
        'event': 'dynamic_form_submit',
        'form_id': id,
        'status': status.valueOf(),
        'call_me_type': type,
        'hph1': hph1,
        'hph2': hph2,
    })
}
